module.exports = __webpack_public_path__ + "img/hexin6.e3eceeae.png";